module.exports = __webpack_public_path__ + "img/email-redaction-screen.5538a54d.png";